import { Component, Vue } from 'vue-property-decorator';

import { copyTextToClipboard } from '../../core/download';
import { MmAuditorMessenger } from '../../types/domain';

import {
	buildMessengerSendActions,
	extractPhoneDigits,
	MmMessengerSendAction,
} from './auditorMessengerSend';

const KEY = 'priceMonitoring.mobileMonitoring.auditors.';

@Component
export default class AuditorMessengerSendMixin extends Vue {
	get messengerSendLogin(): string {
		return '';
	}

	get messengerSendPassword(): string {
		return '';
	}

	get messengerSendMessengers(): MmAuditorMessenger[] | null {
		return null;
	}

	get messengerSendPhone(): string | null {
		return null;
	}

	get messengerGreetingText(): string {
		return this.$t(KEY + 'tempPasswordMessengerGreeting', {
			login: this.messengerSendLogin,
			password: this.messengerSendPassword,
		}) as string;
	}

	get phoneDigits(): string {
		return extractPhoneDigits(this.messengerSendPhone);
	}

	get messengerSendActions(): MmMessengerSendAction[] {
		return buildMessengerSendActions(
			this.messengerSendMessengers,
			this.messengerSendPhone,
			this.messengerGreetingText,
		);
	}

	get messengerSendTitle(): string {
		return this.$t(KEY + 'tempPasswordMessengerSendTitle') as string;
	}

	get messengerContactsEmptyText(): string {
		return this.$t(KEY + 'tempPasswordMessengerContactsEmpty') as string;
	}

	get messengerGreetingCopiedText(): string {
		return this.$t(KEY + 'tempPasswordMessengerGreetingCopied') as string;
	}

	messengerSendLabel(messengerTitle: string): string {
		return this.$t(KEY + 'tempPasswordMessengerSend', { messenger: messengerTitle }) as string;
	}

	openMessenger(action: MmMessengerSendAction): void {
		if (!action.href) {
			return;
		}

		window.open(action.href, '_blank');

		if (action.needsCopy && copyTextToClipboard(this.messengerGreetingText)) {
			this.$message.success(this.messengerGreetingCopiedText);
		}
	}
}
